<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<el-form ref="form" :model="form" label-width="0px">
					<el-divider content-position="center">新品月份</el-divider>
					<el-form-item label="" required>
						<datePicker value-format="timestamp" type="month" v-model="form.newgoodsdate"  />
					</el-form-item>
					<el-divider content-position="center">销售月份</el-divider>
					<el-form-item label="" required>
						<datePicker value-format="timestamp" type="month" v-model="form.trackdate"  />
					</el-form-item>
				</el-form>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import datePicker from '@_system/components/formcomponents/common/datePicker/index.vue'
	//import inputNumber from '@_system/components/formcomponents/common/inputNumber/index.vue'
	export default {
		mixins: [modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
			type: {
				default: () => {
					return 'month'
				}
			},
			unit: {
				default: () => {
					return 'month'
				}
			},
		},
		data() {
			return {
				modal_title: '',
				modal_width: 500,
				modal_height: 500,
				form: {
					newgoodsdate: null,
					trackdate:null
				}
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			modal_init() {
				this.form = {
					newgoodsdate: this.$Moment().subtract(3, 'month').startOf('month').valueOf(),
					trackdate:this.$Moment().subtract(2, 'month').startOf('month').valueOf(),
				}
				this.modal_title = this.data.name
				this.modal_model = true
			},
			// modal_show(){

			// 	this.$api.downloadstatic.getexcle({
			// 		code: this.data.code,
			// 	}).then(() => {
			// 		this.$message.success('创建下载任务成功，文件将推送至钉钉')
			// 		this.modal_cancel()
			// 	})
			// },
			submit() {				
				if (!this.form.newgoodsdate) {
					this.$message.error('请选择新品月份')
					return
				}
				if (!this.form.newgoodsdate) {
					this.$message.error('请选择新品月份')
					return
				}				
				this.$api.downloadstatic.getexcletask({
					code: this.data.code,
					newgoodsdate: this.form.newgoodsdate/1000,
					trackdate: this.form.trackdate/1000
				}).then(() => {
					this.$message.success('创建下载任务成功，文件将推送至钉钉')
					//this.modal_cancel()
				})				
			},
			reset() {

			}
		},
		components: {
			datePicker,
			//inputNumber
		}
	}
</script>